import React, { useEffect, useState, useRef } from "react";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker.js";
import "../styles/Test.css";

import doc from "../documentos/instrumentos/TUPA.pdf";

GlobalWorkerOptions.workerSrc = workerSrc;

function Test() {
  /*const leftCanvas = useRef(null);
  const rightCanvas = useRef(null);

  const [pdf, setPdf] = useState(null);
  const [page, setPage] = useState(1);
  const [zoom, setZoom] = useState(1.2);

  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const loadPDF = async () => {
      try {
        const loadingTask = getDocument(doc);
        const pdfDoc = await loadingTask.promise;
        setPdf(pdfDoc);
        renderPages(pdfDoc, page, zoom);
      } catch (error) {
        console.error("Error cargando PDF:", error);
      }
    };

    loadPDF();
  }, []);

  useEffect(() => {
    if (pdf) renderPages(pdf, page, zoom);
  }, [pdf, page, zoom]);

  const triggerAnimation = () => {
    setAnimating("start");

    setTimeout(() => setAnimating("middle"), 200);
    setTimeout(() => setAnimating("end"), 400);
    setTimeout(() => setAnimating(false), 800);
  };

  const renderPages = async (pdfDoc, currentPage, zoom) => {
    await renderSinglePage(pdfDoc, currentPage, leftCanvas);

    if (currentPage + 1 <= pdfDoc.numPages) {
      await renderSinglePage(pdfDoc, currentPage + 1, rightCanvas);
    } else {
      const ctx = rightCanvas.current.getContext("2d");
      ctx.clearRect(0, 0, rightCanvas.current.width, rightCanvas.current.height);
    }
  };

  const renderSinglePage = async (pdfDoc, num, ref) => {
    const page = await pdfDoc.getPage(num);
    const viewport = page.getViewport({ scale: zoom });

    const canvas = ref.current;
    const ctx = canvas.getContext("2d");

    const dpi = window.devicePixelRatio || 1;

    canvas.width = viewport.width * dpi;
    canvas.height = viewport.height * dpi;

    canvas.style.width = viewport.width + "px";
    canvas.style.height = viewport.height + "px";

    ctx.scale(dpi, dpi);

    await page.render({
      canvasContext: ctx,
      viewport,
    }).promise;
  };

  const previousPage = () => {
    if (page === 1) return;
    triggerAnimation();
    setPage((prev) => (prev > 1 ? prev - 2 : 1));
  };

  const nextPage = () => {
    if (page + 2 <= pdf.numPages) {
      triggerAnimation();
      setPage(page + 2);
    }
  };

  const printPDF = () => {
    const link = document.createElement("a");
    link.href = doc;
    link.download = "documento.pdf";
    link.click();
  };

  return (
    <div className="book-container">
      
      <div className="toolbar">
        <button className="btn" onClick={previousPage}>⟵ Anterior</button>

        <div className="page-info">
          Página {page} - {pdf?.numPages || "?"}
        </div>

        <button className="btn" onClick={nextPage}>Siguiente ⟶</button>

        <button className="btn btn-success" onClick={printPDF}>🖨 Imprimir</button>

        <button className="btn" onClick={() => setZoom((z) => z + 0.1)}>＋</button>
        <button className="btn" onClick={() => setZoom((z) => Math.max(0.5, z - 0.1))}>－</button>
      </div>

      
      <div className={`book-view ${animating ? `page-flip-${animating}` : ""}`}>
        <div className="page">
          <canvas ref={leftCanvas}></canvas>
        </div>

        <div className="page">
          <canvas ref={rightCanvas}></canvas>
        </div>
      </div>
    </div>
  );*/
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <iframe
        src="https://heyzine.com/flip-book/98dfe6c3d6.html#page/1"
        title="Heyzine Flipbook"
        width="100%"
        height="100%"
        frameBorder="0"
      />
    </div>
  );
}

export default Test;
